<template>
  <div style="height: calc(-98px + 100vh)">
    <el-alert :title="obj.model_name" type="info" :closable="false"> </el-alert>
    <div
      class="p-box"
      style="height: calc(100vh - 354px); overflow: auto"
      @scroll="handleScroll"
    >
      <div
        v-for="(item, index) in dh"
        :key="index"
        class="message-item"
        :class="{
          'user-message': index % 2 === 0,
          'bot-message': index % 2 !== 0,
        }"
      >
        {{ item }}
      </div>
    </div>
    <div style="width: 100%">
      <div style="text-align: left; margin-bottom: 10px">
        <el-tag
          type="info"
          size="mini"
          @click="tagFun('有诺贝尔数学奖吗？')"
          style="visibility: hidden"
          >有诺贝尔数学奖吗？</el-tag
        >
        <!-- <el-tag size="mini" type="info" @click="tagFun('有诺贝尔数学奖吗1？')"
          >有诺贝尔数学奖吗1？</el-tag
        ><el-tag type="info" size="mini" @click="tagFun('有诺贝尔数学奖吗2？')"
          >有诺贝尔数学奖吗2？</el-tag
        ><el-tag size="mini" type="info" @click="tagFun('有诺贝尔数学奖吗3？')"
          >有诺贝尔数学奖吗3？</el-tag
        > -->
        <el-popover placement="top" width="250" v-model="visible">
          <p>确认要清除当前会话所有消息吗？</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="visible = false"
              >取消</el-button
            >
            <el-button type="primary" size="mini" @click="delFun"
              >确定</el-button
            >
          </div>

          <el-icon
            slot="reference"
            style="float: right; margin-right: 10px; margin-top: 10px"
            class="el-icon-delete-solid"
          ></el-icon>
        </el-popover>
        <span
          v-if="stopValue"
          @click="stopFun"
          style="
            float: left;
            cursor: pointer;
            margin-right: 10px;
            margin-top: 10px;
            font-size: 12px;
            margin-left: 15px;
          "
          ><el-icon
            class="el-icon-video-pause"
            style="margin-right: 2px"
          ></el-icon
          >停止</span
        >
      </div>
      <el-input
        type="textarea"
        :rows="7"
        placeholder="请输入prompt"
        v-model="textarea"
        @keyup.native="changeBg"
        @keydown.enter.native.prevent="sendFun"
        :disabled="Stopdisabled"
        resize="none"
      >
      </el-input>
      <el-button
        @click="sendFun"
        :disabled="disabled"
        icon="el-icon-s-promotion"
        :style="`color:#fff;padding: 5px;cursor: ${
          disabled ? '' : 'pointer'
        };border-radius: 4px;;position: absolute;right:20px;bottom: 75px;font-size:30px;background:${
          disabled
            ? 'rgb(187 154 243) !important'
            : 'hsl(262.1deg 88.94% 59.19%) !important'
        }`"
      ></el-button>
      <!-- <el-icon disabled class="el-icon-s-promotion" ></el-icon> -->
    </div>
  </div>
</template>
<script>
import hljs from "highlight.js";
import "highlight.js/styles/vs2015.css"; // 黑色主题样式
// import bash from "@highlightjs/highlightjs-bash";
// hljs.registerLanguage("bash", bash);
export default {
  props: {
    str: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      Stopdisabled: false,
      stopValue: false,
      shouldAutoScroll: true, // 新增自动滚动标志
      disabled: true,
      textarea: "",
      visible: false,
      dh: [],
      obj: {},
      streamResponse: "",
      isStreaming: false,
      controller: null, // 用于存储AbortController
      getkey: "",
      getkeyMsg: "",
    };
  },
  // watch() {
  //   this.$watch(
  //     () => this.str,
  //     (newValue, oldValue) => {
  //       this.obj = JSON.parse(this.str)
  //       console.log('this.str',this.str)
  //     }
  //   );
  // },
  // 添加watch配置
  watch: {
    str: {
      immediate: true, // 立即执行一次
      handler(newVal) {
        if (newVal) {
          try {
            this.obj = JSON.parse(newVal);
            console.log("this.str", this.str);
          } catch (e) {
            console.error("JSON解析失败:", e);
          }
        }
      },
    },
  },
  mounted() {
    this.getkeyFun();
    // this.obj = JSON.parse(this.str)
    // console.log('this.str',this.str)
    window.recharge = () => {
      this.recharge();
    };
  },
  beforeDestroy() {
    window.recharge = null; // 避免内存泄漏
  },
  methods: {
    getkeyFun() {
      let data = {
        op: "getkey",
      };

      let _this = this;
      this.$axios
        .post("/index.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            // window.location.href = response.data.data;
            _this.getkey = response.data.data; //response.data.data;//有key
          } else {
            _this.getkey = "";
            _this.getkeyMsg = response.data.msg;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    tagFun(val) {
      this.textarea = val;
      this.disabled = false;
    },
    sendFun() {
      if (this.textarea == "") {
        return;
      }
      if (this.isStreaming) {
        // this.controller?.abort();
        this.$message.error("请稍等片刻，等回复后在发送哦~");
        return;
      }
      this.Stopdisabled = true;

      this.dh.push(this.textarea);

      this.disabled = true;
      this.getbalance();
    },
    handleScroll(event) {
      const container = event.target;
      // 判断是否接近底部（保留5px容差）
      const isNearBottom =
        container.scrollHeight - container.scrollTop <=
        container.clientHeight + 5;
      this.shouldAutoScroll = isNearBottom;
    },
    async sentText() {
      if (this.getkey == "") {
        this.$message.info(this.getkeyMsg);
        setTimeout(() => {
          this.$router.push({ path: "/api" });
        }, 500);
        return;
      }

      try {
        this.isStreaming = true;
        this.controller = new AbortController();
        this.Stopdisabled = false;

        // api的key
        const response = await fetch(`${this.$url}/model/chat_t.do`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json", //"application/x-www-form-urlencoded",
            Authorization: this.getkey,
          },
          //this.Qs.stringify(

          body: JSON.stringify({
            model: this.obj.model_name,
            messages: [
              {
                role: "user",
                content: this.textarea,
              },
            ],
            stream: true,
            max_tokens: this.obj.max_tokens,
            temperature: this.obj.temperature,
            top_p: this.obj.top_p,
            frequency_penalty: this.obj.frequency_penalty,
          }),
          signal: this.controller.signal,
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = "";
        this.dh.push(""); // 添加空消息占位
        this.textarea = "";
        this.streamResponse = "";
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            this.isStreaming = false;
            this.stopValue = false;
            break;
          }
          this.stopValue = true;
          let textChunk = decoder.decode(value, { stream: true });
          console.log("textChunk", textChunk.length);
          console.log("textChunk原始块", textChunk);
          textChunk = textChunk
            .slice(6, -2)
            // textChunk = textChunk.slice(6, -2)
            .replace(/<think>/g, "【 深度思考 】")
            .replace(/<\/think>/g, "【 以下是解决方案 】")
            // .replace(/\n{2}/g, '')// 新增处理连续换行符
            // .replace(/^data:.*?(\n\n)/gm, (match, p1) => {
            //   return match.replace(p1, "");
            // })
            .replace(/\n{2}(?=data:)/g, '')
          
            .replace(/data: /gm, ""); // 新增行首 data: 清除

          // .replace(/\n{2}/g, ''); // 新增处理连续换行符

          console.log("textChunk正则块", textChunk);

          this.streamResponse += textChunk;

          // 更新最后一条消息
          this.$set(this.dh, this.dh.length - 1, this.streamResponse);

          // 自动滚动到底部
          this.$nextTick(() => {
            // const container = this.$el.querySelector('.p-box');
            // container.scrollTop = container.scrollHeight;
            const container = this.$el.querySelector(".p-box");
            if (this.shouldAutoScroll) {
              container.scrollTop = container.scrollHeight;
            }
          });
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("流式请求错误:", error);
          this.stopValue = false;
          this.$message.error("请求失败: " + error.message);
        }
      } finally {
        this.isStreaming = false;
        this.stopValue = false;
      }
    },
    stopFun() {
      this.controller?.abort();
      return;
    },

    goManage() {
      console.log(90);
      let data = {
        op: "login",
      };

      let _this = this;
      this.$axios
        .post("/auth/authcontrol.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            window.location.href = response.data.data;
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getbalance() {
      let data = {
        op: "getbalance",
      };
      let _this = this;
      this.$axios
        .post("/index.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);

          if (response.data.value == "ok") {
            if (
              response.data.data.balance > 0 &&
              response.data.data.state == "可用"
            ) {
              // 继续发送请求
              _this.sentText();
            } else {
              _this.textarea = "";

              _this.$notify({
                dangerouslyUseHTMLString: true,
                message: `<strong>所选模型仅限充值余额支付，您的充值余额不足或者已被禁用，请联系管理员再试</strong>`,
                duration: 0,
              });
              _this.$set(_this.dh, _this.dh.length, "模型请求出错！");
            }
            // _this.$notify({
            //     dangerouslyUseHTMLString: true,
            //     message: `<strong>所选模型仅限充值余额支付，您的充值余额不足，请充值后再试</strong><br><br><span style=" color:#7c3aed;cursor:pointer;margin-top:10px;" onclick="window.recharge()">立即充值</span>`,
            //     duration: 0,
            //   });
          }
          if (response.data.value == "login_error") {
            //未登录
            _this.$message({
              message: response.data.msg,
              type: "info",
            });
            setTimeout(() => {
              _this.goManage();
            }, 1000);
          } else {
            // _this.$message.info(response.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    changeBg() {
      console.log(999, this.textarea);
      if (this.textarea != "") {
        this.disabled = false;
        return;
      } else {
        this.disabled = true;
      }
    },
    delFun() {
      if (this.isStreaming) {
        this.controller?.abort();
      }
      this.visible = false;
      this.textarea = "";
      this.disabled = true;
      this.dh = [];
    },
    recharge() {
      let data = {
        op: "recharge",
        id: window.localStorage.getItem("anjing_id_group"),
        amount: "30",
      };

      let _this = this;
      this.$axios
        .post("/_admin/users.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            window.location.href = response.data.data;
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
/deep/.el-alert__title {
  font-weight: bold;
  color: #000;
}
/deep/.el-textarea__inner {
  padding-right: 50px;
}
/deep/.el-tag.el-tag--info {
  background-color: rgb(241 245 249) !important;
  color: rgb(100 116 139/1) !important;
  padding: 0 10px;
  cursor: pointer;
}
/deep/.el-button--text {
  color: rgb(127, 58, 243) !important;
}
/deep/.el-button--primary {
  background: rgb(127, 58, 243) !important;
  border: 1px solid rgb(127, 58, 243) !important;
}
/* 父容器添加flex布局 */
.p-box {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
}
/* /deep/.el-notification__group span{
  color:#7c3aed
}
/deep/.el-notification__group span:hover{
  color:#ad83f6
} */
/* 用户消息样式 */
.user-message {
  width: fit-content;

  max-width: 80%;
  background-color: #e0e7ff;
  margin: 8px;
  border-radius: 6px 6px 0 6px;
  margin-left: auto; /* 靠右对齐 */
  position: relative;
  text-align: left;
  background-color: #e0e7ff;
  border-radius: 12px 4px 12px 12px;
  margin-left: auto;
  margin-right: 8px;
}

/* 机器人消息样式 */
.bot-message {
  text-align: left;
  background-color: #f8fafc;
  border-radius: 4px 12px 12px 12px;
  margin-right: auto;
  margin-left: 8px;
  max-width: calc(80% - 16px); /* 增加间距补偿 */
}
/* 强制文本换行 */
.p-box {
  white-space: pre-wrap;
  word-wrap: break-word;
}

/* 对话气泡效果 */
.message-item {
  position: relative;
  padding: 12px;
  max-width: 80%;
  min-width: 20%; /* 添加最小宽度 */
  word-break: break-word; /* 强制换行 */
  box-sizing: border-box; /* 包含padding */
}

/* .user-message::before {
  content: '';
  position: absolute;
  right: -8px;
  top: 0;
  border-width: 0 8px 8px 0;
  border-style: solid;
  border-color: transparent #e0e7ff transparent transparent;
} */

/* .bot-message::before {
  content: '';
  position: absolute;
  left: -8px;
  top: 0;
  border-width: 0 0 8px 8px;
  border-style: solid;
  border-color: transparent transparent transparent #f8fafc;
} */
</style>
